import React, { useEffect, useState, useRef } from "react";
import { useNotification } from "../../hooks/useNotification";
import { Button, List, Modal, Typography, Empty, theme, Skeleton } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
const { Paragraph, Title } = Typography;

const NotificationsPop = () => {
  const { token } = theme.useToken();
  const isAuthenticated = useSelector((state) => state.oauth.isAuthenticated);
  const {
    notificationHistory,
    clearHistory,
    removeNotificationFromHistory,
    notificationPop,
    setNotificationPop,
    notificationButtonRef,
  } = useNotification();
  const [selectedNotification, setSelectedNotification] = useState(null);
  const popRef = useRef(null);
  useEffect(() => {
    console.log("notification history changed");
    console.log(notificationHistory);
  }, [notificationHistory]);

  const iconMap = {
    info: (
      <InfoCircleOutlined style={{ color: "#1890ff", fontSize: "1.5rem" }} />
    ),
    success: (
      <CheckCircleOutlined style={{ color: "#52c41a", fontSize: "1.5rem" }} />
    ),
    warning: (
      <ExclamationCircleOutlined
        style={{ color: "#faad14", fontSize: "1.5rem" }}
      />
    ),
    error: (
      <CloseCircleOutlined style={{ color: "#f5222d", fontSize: "1.5rem" }} />
    ),
  };

  useEffect(() => {
    if (!selectedNotification) {
      const handleClickOutside = (event) => {
        if (
          popRef.current &&
          !popRef.current.contains(event.target) &&
          notificationPop
        ) {
          const isButtonClick = notificationButtonRef.current?.contains(
            event.target
          );
          console.log("isButtonClick", isButtonClick);
          if (!isButtonClick) {
            setNotificationPop(false);
          }
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [
    selectedNotification,
    notificationPop,
    setNotificationPop,
    notificationButtonRef,
  ]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    notificationPop && (
      <div
        ref={popRef}
        style={{
          zIndex: 95,
          position: "fixed",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "28em",
          height: "100%",
          paddingTop: "62px",
          paddingBottom: "24px",
          right: "0px",
        }}
      >
        <div
          className="modal-shadow"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            overflowY: "auto",
            margin: "0 auto",
            backgroundColor: "var(--tertiary-color)",
            padding: " 16px 16px 24px 16px",
            // paddingBottom: "24px",
            borderRadius: `${token.cardRadius} ${token.borderRadius} ${token.borderRadius} ${token.cardRadius}`,
            marginTop: "24px",
            top: "16px",
          }}
        >
          <h3 style={{ marginBottom: "16px", paddingLeft: "8px" }}>
            Notifications
          </h3>
          <List
            style={{ width: "100%", height: "100%", overflowY: "auto" }}
            dataSource={notificationHistory}
            renderItem={(notification) => (
              <List.Item
                className={`notification ${notification.type}`}
                style={{
                  position: "relative",
                  padding: "16px 20px",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  display: "flex",
                  alignItems: "flex-start",
                  border: "1px solid #f0f0f0",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedNotification(notification)}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  {/* Icon on the left */}
                  <div
                    style={{
                      display: "flex",
                      marginRight: "12px",
                    }}
                  >
                    {iconMap[notification.type]}
                  </div>

                  {/* Notification content */}
                  <div style={{ flex: 1 }}>
                    <List.Item.Meta
                      title={notification.title}
                      description={
                        <Paragraph
                          ellipsis={{ rows: 2, expandable: false }}
                          style={{ marginBottom: 0 }}
                        >
                          {notification.message}
                        </Paragraph>
                      }
                    />
                  </div>
                </div>

                {/* Close button in top-right corner */}
                <Button
                  shape="circle"
                  size="small"
                  icon={
                    <CloseCircleOutlined
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "16px",
                      }}
                    />
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    removeNotificationFromHistory(notification);
                  }}
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    zIndex: 1,
                  }}
                />
              </List.Item>
            )}
            locale={{
              emptyText: (
                <Empty
                  style={{
                    marginTop: "20vh",
                  }}
                  description="No notifications"
                />
              ),
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button type="primary" size="middle" onClick={clearHistory}>
              Clear
            </Button>
          </div>

          <Modal
            open={!!selectedNotification}
            onCancel={() => setSelectedNotification(null)}
            footer={null}
            width="80%"
            centered
          >
            {selectedNotification && (
              <div>
                <Title level={4}>{selectedNotification.title}</Title>
                <Paragraph>{selectedNotification.message}</Paragraph>
              </div>
            )}
          </Modal>
        </div>
      </div>
    )
  );
};

export default NotificationsPop;
